import Test from '../Trip/Trip'
import car from '../../images/suv3.png'
import letter from '../../images/logo3.jpg'
import shape from '../../images/flight-land-round-24px 2.png'
import travel from '../../images/travel.png'
import standard from '../../images/corola1.png'
import suv from '../../images/suv.png'
import grand from '../../images/grand.webp'
import mini from '../../images/download.png'
import van from '../../images/b2.png'
import coaster from '../../images/coaster1.png'
import power from '../../images/copy-2.f9270318.jpg'
import { IoMdPlay } from "react-icons/io";
import { IoIosCloseCircleOutline } from "react-icons/io";



import './Home.css'
import { useRef, useState } from 'react'

function Home() {

    const videoRef = useRef(null);

      const pauseVideo = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };


const [show,setShow]=useState(false)
const [stop,setStop]=useState(false)
  return (
    <>
        <div className="home pt-5">
        <div className="container-fluid pt-5">
            <div className="row">
                <div className="col-lg-6 col-md-12 text">
                    <p>Tired of dealing with cumbersome car services?</p>
                    <h1>Explore a New Era of <br />  <span>Luxurious and Eco-Friendly Transportation</span></h1>    
                    <img src={car} alt="car" />
                                </div>
                <div className="col-lg-6 col-md-12">
                    <Test/>
                </div>
            </div>
        </div>
    </div>
    <div className="services">
        <div className="container">
            <div className="text text-center">
                <img src={letter} alt="letter" />
                <h2>Comfort LIMO SERVICES</h2>
                <p>All Your Needs Fulfilled.</p>
            </div>
            <div className="row">
                <div className="col-md-6 col-sm-12">
                    <div className="details text-center pt-4">
                        <img src={shape} alt="shape" />
                        <h5>Airport Limousine</h5>
                        <p>Get your luxury trip to & from the airport</p>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12">
                    <div className="details text-center pt-4">
                        <img src={travel} alt="shape" />
                        <h5>Travel in Style</h5>
                        <p>Travel with no worry about the road</p>
                    </div>
                </div>
            </div>
            
        </div>
        <div className="container-fluid px-5">
            <div className="message">
                <p>From booking to arrival, enjoy a seamless and exceptional journey. Whether you're heading to the airport, traveling within the city, or going from city to city, Comfort Limo delivers the ride you deserve.</p>
            </div>
            <div className="video mb-5">
                <div className="photo">
                    <IoMdPlay className='play' onClick={()=>{setShow(true)
                        setStop(true)
                    }}/>
                    <h4>Explore comfortlimo</h4>
                    <span>Watch Full Video</span>
                
      {
        stop?<IoIosCloseCircleOutline className=' position-absolute close'  onClick={()=>{setShow(false)
            setStop(false) 
            pauseVideo()
        }}/>:null
      }

                </div>
                <video ref={videoRef}  width="100%" height='100%'  controls className={show? ' sound position-absolute active' :' sound position-absolute'}>
<source src={`${process.env.PUBLIC_URL}/v2.mp4`} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
            </div>
            <div className="fleets">
                <h3>COMFORT LIMO FLEET</h3>
                <p className='hint'>Find The Ride That Matches Your Style</p>
                <ul className='list'>
                    <li className='item'>
                        <div className="all">
                            <div className="image">
                                <img src={standard} alt="standard" />
                            </div>
                            <div className="text">
                                <h5>Standard</h5>
                                <p>Toyota, Elentra ,Kia & Similar Starting From 2021</p>
                                <p>3 Passengers</p>
                                
                            </div>
                        </div>
                    </li>
                    
                    <li className='item'>
                        <div className="all">
                            <div className="image">
                                <img src={suv} alt="standard" className='suv'  />
                            </div>
                            <div className="text">
                                <h5>SUV</h5>
                                <p>Tucson, Sportage ,MG zs & Similar Starting From 2021</p>
                                <p>4 Passengers</p>
                            </div>
                        </div>
                    </li>
                    <li className='item'>
                        <div className="all">
                            <div className="image">
                                <img src={grand} alt="standard" />
                            </div>
                            <div className="text">
                                <h5 >SUV Grand</h5>
                                <p>Xpander, Glory ,Ortega & Similar Starting From 2021</p>
                                <p>6 Passengers</p>
                            </div>
                        </div>
                    </li>
                    <li className='item'>
                        <div className="all">
                            <div className="image">
                                <img src={mini} alt="standard" />
                            </div>
                            <div className="text">
                                <h5 className='energy'>Mini Van (VIP) </h5>
                                <p>Hyundai H1 Starting From 2020</p>
                                <p>From 7 To 9 Passengers</p>
                            </div>
                        </div>
                    </li>
                    <li className='item'>
                        <div className="all">
                            <div className="image">
                                <img src={van} alt="standard" />
                            </div>
                            <div className="text">
                                <h5>Van</h5>
                                <p>Toyota HIAS Starting From 2022</p>
                                <p>13 Passengers</p>
                            </div>
                        </div>
                    </li>
                    <li className='item'>
                        <div className="all">
                            <div className="image">
                                <img src={coaster} alt="standard" />
                            </div>
                            <div className="text">
                                <h5>Coaster</h5>
                                <p>Toyota Coaster Starting From 2020</p>
                                <p>From 22 To 24 Passengers</p>
                            </div>
                        </div>
                    </li>
                </ul>
                <a href="#/">Explore Our Fleet</a>
                
            </div>
            <div className="frind">
                <div className="box">
                    <h3>ECO FRIENDLY</h3>
                    <span>Protect the environment with ComfortLimo</span>
                    <p>Sustainable living is essential now more than ever, which is why we’re committed to reducing our carbon footprint by offering eco-luxury vehicles. Enhance your luxury travel experience with ComfortLimo's exclusive eco-friendly fleet.</p>
                </div>
            </div>
            <div className="power">
                <div className="text">
                    <h4>ABOUT COMFORT LIMO</h4>
                    <h3>Driven by a passion for innovation</h3>
                    <p>relish the moments when you prefer not to drive while still enjoying the luxury of elegant rides. We're crafting a realm of eco-friendly transportation that embodies luxury in every aspect.</p>
              <a href="#/">Learn More</a>
                </div>
                <div className="image"> 
                    <img src={power} alt="about" />
                </div>
            </div>
            
        </div>
        
    </div>
     
    </>
  )
}

export default Home